import React from 'react';
import { Typography } from '@material-ui/core';
import { useHistory } from 'react-router';
import { ListItemText, ItemList as ListItem } from './styles';

const TransItemList: React.FC<{
  tag: string;
  label: string;
  color: string;
  backgroundColor?: string;
  title?: boolean;
  disabled?: boolean;
  setDrawerOpen: (open: boolean) => boolean;
}> = ({
  tag,
  label,
  color,
  backgroundColor,
  title,
  setDrawerOpen,
  disabled,
}) => {
  const history = useHistory();

  const goTo = (to: string) => {
    try {
      history.push(to);
    } catch {
      // we must fix this
    }
    setDrawerOpen(false);
  };

  return (
    <ListItem
      button
      onClick={() => goTo(`/${tag}/transaction`)}
      style={{
        width: '100%',
        backgroundColor,
        ...(title ? { marginBottom: '6%', marginTop: '3%' } : null),
      }}
      disabled={disabled}
    >
      <ListItemText
        color={color}
        primary={
          <Typography variant={title ? 'body1' : 'body1'}>{label}</Typography>
        }
      />
    </ListItem>
  );
};

export default TransItemList;
